import { toast } from 'react-toastify'

import { CustomFetchBaseQueryError } from './types'

/**
 * Handles RTK Query errors and displays appropriate toast messages
 * @param error - The error object from RTK Query
 * @param defaultMessage - Default message to show when error details aren't available
 */
export const handleRtkQueryError = (
	error: unknown,
	defaultMessage = 'Failed to fetch diagram data',
): void => {
	if (!error) return

	// Check if it's a CustomFetchBaseQueryError type
	if (typeof error === 'object' && 'data' in error) {
		const customError = error as CustomFetchBaseQueryError
		const errorCode = customError?.data?.errorCode || 'Error'
		const errorDescription =
			customError?.data?.errorDescription || defaultMessage
		const errorMessage = `${errorCode}: ${errorDescription}`

		toast.error(errorMessage)
		return
	}

	// Handle other error types
	toast.error(defaultMessage)
}

/**
 * Casts a payload object to the RTK Query CreateUsingPostApiArg body type.
 * This is needed because the backend type uses `{ [key: string]: object }`,
 * which doesn't accept primitives used in DTOs like MassExportConfigDto or TechnicalColumnDto.
 *
 * @param payload - The payload object to cast (e.g., MassExportConfigDto, TechnicalColumnDto)
 * @returns The payload cast to the required body type
 */
export const castCreateUsingPostBody = <T>(
	payload: T,
): { [key: string]: object } => {
	return payload as unknown as { [key: string]: object }
}
